module.exports = __webpack_public_path__ + "ptc_momoro_J1.35f3d2aa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/momoro/parent_to_child/ptc_momoro_J1.jpg
// module id = uERe
// module chunks = 0